import { zodResolver } from '@hookform/resolvers/zod';
import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
  UseFormReturn,
} from 'react-hook-form';
import { IFinancialStatementsFormValues } from './types';
import { FinancialStatementsSchema } from './validators';

type FinancialStatementsFormContext =
  UseFormReturn<IFinancialStatementsFormValues>;

type FinancialStatementsFormSubmission = (
  formUtils: FinancialStatementsFormContext
) => SubmitHandler<IFinancialStatementsFormValues>;

type FinancialStatementsFormProviderProps = {
  children: React.ReactNode;
  onSubmit?: FinancialStatementsFormSubmission;
  initialValues?: IFinancialStatementsFormValues;
};

const useFinancialStatementsForm = () =>
  useFormContext<IFinancialStatementsFormValues>();

const defaultFormValues: IFinancialStatementsFormValues =
  {} as IFinancialStatementsFormValues;

const FinancialStatementsProvider = (
  props: FinancialStatementsFormProviderProps
) => {
  const { children, onSubmit, initialValues } = props;

  const formContext = useForm<IFinancialStatementsFormValues>({
    mode: 'onChange',
    defaultValues: initialValues ?? defaultFormValues,
    resolver: zodResolver(FinancialStatementsSchema),
  });

  const handleSubmit = onSubmit
    ? formContext.handleSubmit(onSubmit(formContext))
    : (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
      };

  return (
    <FormProvider {...formContext}>
      <form onSubmit={handleSubmit}>{children}</form>
    </FormProvider>
  );
};

export { useFinancialStatementsForm };
export default FinancialStatementsProvider;
